import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-stop';
export var ID = 'icon-stop';
/* eslint-disable max-len */

export var SVGStop = function SVGStop() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 8 8"
  }, React.createElement("g", {
    transform: "translate(-1105.000000, -224.000000)"
  }, React.createElement("rect", {
    x: "1105",
    y: "224",
    width: "8",
    height: "8"
  })));
};
/* eslint-disable max-len */

var Stop = function Stop(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGStop
  });
};

Stop.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Stop;